import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=fd003b8e&scoped=true"
import script from "./SelectCategory.vue?vue&type=script&lang=js"
export * from "./SelectCategory.vue?vue&type=script&lang=js"
import style0 from "./SelectCategory.vue?vue&type=style&index=0&id=fd003b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd003b8e",
  null
  
)

export default component.exports